import React from "react";

function renderInline(text) {
  const raw = String(text || "");
  if (!raw) return [""];

  const tokens = [];
  let i = 0;
  const pushText = (t) => {
    if (t) tokens.push(t);
  };

  // React will safely escape plain strings, so we should NOT pre-escape,
  // otherwise entities like "&amp;" will render literally.
  while (i < raw.length) {
    // bold
    if (raw.slice(i, i + 2) === "**") {
      const end = raw.indexOf("**", i + 2);
      if (end > i + 2) {
        const content = raw.slice(i + 2, end);
        tokens.push(<strong key={`b-${i}`}>{content}</strong>);
        i = end + 2;
        continue;
      }
    }
    // italic _..._
    if (raw[i] === "_") {
      const end = raw.indexOf("_", i + 1);
      if (end > i + 1) {
        const content = raw.slice(i + 1, end);
        tokens.push(<em key={`i-${i}`}>{content}</em>);
        i = end + 1;
        continue;
      }
    }
    // italic *...*
    if (raw[i] === "*") {
      const end = raw.indexOf("*", i + 1);
      if (end > i + 1) {
        const content = raw.slice(i + 1, end);
        tokens.push(<em key={`s-${i}`}>{content}</em>);
        i = end + 1;
        continue;
      }
    }

    // plain text chunk until next special char
    const next = (() => {
      const candidates = ["**", "_", "*"]
        .map((m) => raw.indexOf(m, i + 1))
        .filter((n) => n !== -1);
      return candidates.length ? Math.min(...candidates) : -1;
    })();
    if (next === -1) {
      pushText(raw.slice(i));
      break;
    }
    pushText(raw.slice(i, next));
    i = next;
  }

  return tokens.length ? tokens : [raw];
}

export default function SimpleMarkdown({ text = "" }) {
  const lines = String(text || "").replace(/\r\n/g, "\n").split("\n");
  const blocks = [];

  let listBuffer = [];
  const flushList = () => {
    if (!listBuffer.length) return;
    blocks.push(
      <ul key={`ul-${blocks.length}`}>
        {listBuffer.map((li, idx) => (
          <li key={`li-${idx}`}>{renderInline(li)}</li>
        ))}
      </ul>
    );
    listBuffer = [];
  };

  lines.forEach((line) => {
    const trimmed = line.trimEnd();
    const bulletMatch = /^\s*[-*]\s+(.+)$/.exec(trimmed);
    if (bulletMatch) {
      listBuffer.push(bulletMatch[1]);
      return;
    }
    flushList();
    if (!trimmed.trim()) {
      blocks.push(<div key={`sp-${blocks.length}`} style={{ height: 10 }} />);
      return;
    }
    blocks.push(
      <p key={`p-${blocks.length}`} style={{ margin: 0 }}>
        {renderInline(trimmed)}
      </p>
    );
  });
  flushList();

  return <>{blocks}</>;
}

